import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function useFocusOnRouteChange() {
    const location = useLocation();
    const mainRef = useRef<HTMLElement>(null);
    const isFirstRender = useRef(true);

    useEffect(() => {
        // Don't steal focus on initial render
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        // Focus the main content area after route change
        const mainEl = mainRef.current ?? document.getElementById('main-content');
        if (mainEl) {
            mainEl.focus({ preventScroll: false });
            mainEl.scrollTop = 0;
        }
    }, [location.pathname]);

    return mainRef;
}